import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { RadioButton } from 'primereact/radiobutton';
import { Title } from 'components/Title';
import { Uploader } from 'components/Uploader';
import useApi from 'hooks/useApi';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const LoanguarantorAddPage = (props) => {
		const app = useApp();
	const api = useApi();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		loanaccountno: yup.string().required().label($t('loanaccountno')),
		memberid: yup.string().required().label($t('gurantorId')),
		relationship: yup.string().nullable().label($t('relationship')),
		guaranteeamount: yup.number().nullable().label($t('guaranteeamount')),
		fullname: yup.string().nullable().label($t('fullname')),
		address1: yup.string().nullable().label($t('address1')),
		address2: yup.string().nullable().label($t('address2')),
		mobileno: yup.string().nullable().label($t('mobileno')),
		gender: yup.string().nullable().label($t('gender')),
		marital_status: yup.string().nullable().label($t('maritalStatus')),
		id_type: yup.string().nullable().label($t('idType')),
		idcardno: yup.string().nullable().label($t('idcardno')),
		id_image: yup.string().nullable().label($t('idImage')),
		photo: yup.string().nullable().label($t('photo'))
	});
	
	//form default values
	const formDefaultValues = {
		loanaccountno: '', 
		memberid: '', 
		relationship: '', 
		guaranteeamount: '', 
		fullname: '', 
		address1: '', 
		address2: '', 
		mobileno: '', 
		gender: '', 
		marital_status: '', 
		id_type: '', 
		idcardno: '', 
		id_image: '', 
		photo: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/loanguarantor`);
		}
	}
	
	//auto fill other inputs on memberid change
	async function memberidAutoFill(e, formik, index) {
		formik.handleChange(e);
		const val = e.target.value;
		const resp = await api.get(`components_data/loanguarantor_memberid_autofill?value=${val}`);
		const data = resp.data[0];
		if(data){
formik.setFieldValue('relationship', data.nominee_relation);
formik.setFieldValue('fullname', data.membername);
formik.setFieldValue('address1', data.AddressLine1);
formik.setFieldValue('address2', data.AddressLine2);
formik.setFieldValue('mobileno', data.MobileNo);
formik.setFieldValue('gender', data.gender);
formik.setFieldValue('marital_status', data.marital_status);
formik.setFieldValue('photo', data.photo_upload);
formik.setFieldValue('id_type', data.ID1);
formik.setFieldValue('idcardno', data.IDCardNumber);
formik.setFieldValue('id_image', data.id_upload);
		}
	};
    //auto fill other inputs on memberid change
    async function memberidAutoFill(e, formik, index) {
        formik.handleChange(e);
        const val = e.target.value;
        const resp = await api.get(`components_data/loanguarantor_memberid_autofill?value=${val}`);
        const data = resp.data[0];
        if(data){
            formik.setFieldValue('fullname', data.membername);
            formik.setFieldValue('address1', data.addressLine1);
            formik.setFieldValue('address2', data.addressLine2);
            formik.setFieldValue('mobileno', data.mobileNo);
            formik.setFieldValue('gender', data.gender);
            formik.setFieldValue('marital_status', data.marital_status);
            formik.setFieldValue('photo', data.photo_upload);
            formik.setFieldValue('id_type', data.iD1);
            formik.setFieldValue('idcardno', data.idCardNumber);
            formik.setFieldValue('id_image', data.id_upload);
        }
    };
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="LoanguarantorAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('addNewLoanguarantor')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="col comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('loanaccountno')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/loanaccountno_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="loanaccountno"     optionLabel="label" optionValue="value" value={formik.values.loanaccountno} onChange={formik.handleChange} options={response} label={$t('loanaccountno')}  placeholder={$t('selectAValue')} filter={true} className={inputClassName(formik?.errors?.loanaccountno)}   />
                                                    <ErrorMessage name="loanaccountno" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('gurantorId')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/memberid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="memberid"     optionLabel="label" optionValue="value" value={formik.values.memberid} onChange={(e)=>memberidAutoFill(e, formik)} options={response} label={$t('gurantorId')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.memberid)}   />
                                                    <ErrorMessage name="memberid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('relationship')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/relationship_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="relationship"     optionLabel="label" optionValue="value" value={formik.values.relationship} onChange={formik.handleChange} options={response} label={$t('relationship')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.relationship)}   />
                                                    <ErrorMessage name="relationship" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('guaranteeamount')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="guaranteeamount"  onChange={formik.handleChange}  value={formik.values.guaranteeamount}   label={$t('guaranteeamount')} type="number" placeholder={$t('enterGuaranteeamount')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.guaranteeamount)} />
                                                <ErrorMessage name="guaranteeamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('fullname')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="fullname"  onChange={formik.handleChange}  value={formik.values.fullname}   label={$t('fullname')} type="text" placeholder={$t('enterFullname')}        className={inputClassName(formik?.errors?.fullname)} />
                                                <ErrorMessage name="fullname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('address1')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="address1"  onChange={formik.handleChange}  value={formik.values.address1}   label={$t('address1')} type="text" placeholder={$t('enterAddress1')}        className={inputClassName(formik?.errors?.address1)} />
                                                <ErrorMessage name="address1" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('address2')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="address2"  onChange={formik.handleChange}  value={formik.values.address2}   label={$t('address2')} type="text" placeholder={$t('enterAddress2')}        className={inputClassName(formik?.errors?.address2)} />
                                                <ErrorMessage name="address2" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('mobileno')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="mobileno"  onChange={formik.handleChange}  value={formik.values.mobileno}   label={$t('mobileno')} type="text" placeholder={$t('enterMobileno')}        className={inputClassName(formik?.errors?.mobileno)} />
                                                <ErrorMessage name="mobileno" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('gender')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                {
                                                app.menus.gender.map((option) => {
                                                return (
                                                <div key={option.value} className="field-radiobutton">
                                                    <RadioButton inputId={option.value} name="gender" value={option.value} onChange={formik.handleChange}  checked={formik.values.gender === option.value} className={inputClassName(formik?.errors?.gender, '')} />
                                                    <label htmlFor={option.value}>{option.label}</label>
                                                </div>
                                                )
                                                })
                                                }
                                                <ErrorMessage name="gender" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('maritalStatus')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="marital_status"  onChange={formik.handleChange}  value={formik.values.marital_status}   label={$t('maritalStatus')} type="text" placeholder={$t('enterMaritalStatus')}        className={inputClassName(formik?.errors?.marital_status)} />
                                                <ErrorMessage name="marital_status" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('idType')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="id_type"  onChange={formik.handleChange}  value={formik.values.id_type}   label={$t('idType')} type="text" placeholder={$t('enterIdType')}        className={inputClassName(formik?.errors?.id_type)} />
                                                <ErrorMessage name="id_type" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('idcardno')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="idcardno"  onChange={formik.handleChange}  value={formik.values.idcardno}   label={$t('idcardno')} type="text" placeholder={$t('enterIdcardno')}        className={inputClassName(formik?.errors?.idcardno)} />
                                                <ErrorMessage name="idcardno" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('idImage')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.id_image)}>
                                                    <Uploader name="id_image" showUploadedFiles value={formik.values.id_image} uploadPath="fileuploader/upload/id_image" onChange={(paths) => formik.setFieldValue('id_image', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label={$t('chooseFilesOrDropFilesHere')} onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="id_image" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('photo')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className={inputClassName(formik?.errors?.photo)}>
                                                    <Uploader name="photo" showUploadedFiles value={formik.values.photo} uploadPath="fileuploader/upload/photo" onChange={(paths) => formik.setFieldValue('photo', paths)} fileLimit={1} maxFileSize={3} accept=".jpg,.png,.gif,.jpeg" multiple={false} label={$t('chooseFilesOrDropFilesHere')} onUploadError={(errMsg) => app.flashMsg('Upload error', errMsg, 'error')} />
                                                </div>
                                                <ErrorMessage name="photo" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('submit')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
LoanguarantorAddPage.defaultProps = {
	primaryKey: 'guarantorid',
	pageName: 'loanguarantor',
	apiPath: 'loanguarantor/add',
	routeName: 'loanguarantoradd',
	submitButtonLabel: $t('submit'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default LoanguarantorAddPage;
